var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"logo-font logo-green",style:({ 'font-size': _vm.size == 'small' ? '30px' : '48px' })},[_vm._v("游")]),_c('span',{staticClass:"logo-font logo-red",style:({ 'font-size': _vm.size == 'small' ? '30px' : '48px' })},[_vm._v("用工")])])
}
var staticRenderFns = []

export { render, staticRenderFns }